import { Outlet } from "react-router-dom";

import { HomeShell } from "@/features/home/HomeShell";
import { AppProvider } from "@rook/shared/lib/appContext";

/**
 * Layout route for /home/*. AuthGuard wraps THIS in App.tsx, so
 * by the time HomeRoute renders we know there's a session.
 *
 * AppProvider lives here (not at the App.tsx root) so the env
 * switcher state is scoped to the authenticated portion of the
 * tree — no point in seeding it on the public auth pages.
 */
export const HomeRoute = () => (
  <AppProvider>
    <HomeShell>
      <Outlet />
    </HomeShell>
  </AppProvider>
);
